import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

interface ISendPinWhatsappPayload {
  user_id: string;
  user_mobile_number: string;
  created_by?: string;
  intent?: string;
  clinic_id?: string | number;
  source?: string;
  booking_id?: string;
}

interface ISendPinWhatsappResponse {
  status: boolean;
  message?: string;
  data?: any;
}

export const useSendUserProfilePinWhatsappAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async (payload: ISendPinWhatsappPayload) => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const endpoint = CUSTOMER_APIS?.SEND_PIN_WHATSAPP?.baseURL;

      const response = await axios
        .post(endpoint ?? "", payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<ISendPinWhatsappResponse>) => {
          if (res?.data?.status) {
            return { status: true, message: res?.data?.message ?? "PIN sent via WhatsApp" };
          }
          return { status: false, message: res?.data?.message ?? "Failed to send PIN" };
        })
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e);
          const message = (e?.response?.data as any)?.message ?? "Failed to send PIN";
          return { status: false, message };
        });

      return response;
    } catch (e: any) {
      return { status: false, message: e.message };
    }
  }, []);

  return { execute };
};
